module.exports = __webpack_public_path__ + "img/chevron-right.fe45aa70.svg";